export default [0, 502, 503, 504, 511];
